import { createSlice } from '@reduxjs/toolkit'
import { setNestedKey } from '../../../../../helpers/common'
import { register } from '../../../../../helpers/reducerRegistry'
import {
  FIELD_SORT_TABLE_PORTFOLIO_DETAIL,
  TYPE_SORT,
} from '../../../../constant'
import { handleSelectAllIdInTable } from '../../../../helper'
import {
  convertDataTableSavePortfolio,
  convertTypeAlert,
  getDataSizeTable,
  getListIdTableSavePortfolio,
} from '../../helper'
import {
  getAlertProfile,
  getHeaderSavedPortfolio,
  getIdPortfolioAllByOrg,
  getSavedPortfolioByOrg,
  getSearchCompany,
  getSearchPortfolio,
  getSearchPortfolioAll,
  postCreatePortfolio,
} from '../thunk'

const initialState = {
  dataTableSavedPortfolio: {},
  idsTableSavedPortfolio: [],
  dataRawTableSavedPortfolio: [],
  selectCheckBox: {
    listIdsSelected: {},
    listIdAllByTerm: [],
  },
  dataPage: {
    page: 1,
    pageSize: 20,
    totalRecords: 0,
    totalPage: 0,
  },
  filter: {
    sortBy: FIELD_SORT_TABLE_PORTFOLIO_DETAIL.UPDATE_DATE,
    sortDirection: TYPE_SORT.DESCENDING,
  },
  isLoading: {
    savedPortfolioTable: false,
    headerSavedPortfolio: false,
    alertProfile: false,
    searchCompany: true,
    savedPortfolioTableAll: true,
    getAllIdByPort: true,
  },
  total: {
    totalPortfolios: 0,
    totalCompanies: 0,
  },
  typeAlert: [
    {
      label: 'library.main.NOT_SET',
      value: 0,
      isI18n: true,
    },
  ],
  dataSearchCompany: [],
  textSearch: '',
  idCompanySearch: 0,
  textSearchAddCompany: '',
  validateNameCreatePortfolio: '',
}

const slice = createSlice({
  name: 'library/savedPortfolios',
  initialState,
  reducers: {
    resetStore(state) {
      Object.keys(initialState).forEach((key) => {
        if (key === 'typeAlert') return null
        state[key] = initialState[key]
      })
    },
    changeDataInRow: (state, action) => {
      const { rowId, colId, value } = action.payload
      state.dataTableSavedPortfolio[rowId][colId] = value
    },
    changePageSizeTable: (state, action) => {
      state.dataPage = {
        ...state.dataPage,
        ...action.payload,
      }
    },
    changeFilter: (state, action) => {
      state.filter = { ...state.filter, ...action.payload }
    },
    changeIdCompanySearch: (state, action) => {
      state.idCompanySearch = action.payload
    },
    clearDataTable: (state) => {
      const listReset = [
        'dataTableSavedPortfolio',
        'idsTableSavedPortfolio',
        'dataPage',
        'selectCheckBox',
        'dataPage',
        'filter',
      ]
      listReset.forEach((key) => {
        state[key] = initialState[key]
      })
    },
    changeTextSearchAddCompany: (state, action) => {
      state.textSearchAddCompany = action.payload
    },
    clearValidateNameCreatePortfolio: (state) => {
      state.validateNameCreatePortfolio = ''
    },
    clearSearchCompany: (state) => {
      state.textSearchAddCompany = ''
      state.dataSearchCompany = []
      state.isLoading.searchCompany = true
    },
    changeCheckboxTable: (state, action) => {
      const { path, data } = action.payload
      setNestedKey(state.selectCheckBox, path, data)
    },
    selectAllIdInTable: (state, action) => {
      state.selectCheckBox.listIdsSelected = handleSelectAllIdInTable(
        state.selectCheckBox.listIdsSelected,
        state.idsTableSavedPortfolio,
        action.payload,
      )
    },
    selectAllIdByTerm: (state, action) => {
      state.selectCheckBox.listIdsSelected = handleSelectAllIdInTable(
        state.selectCheckBox.listIdsSelected,
        state.selectCheckBox.listIdAllByTerm,
        action.payload,
      )
    },
    unSelectAllCheckbox: (state) => {
      state.selectCheckBox.listIdsSelected = {}
    },
    removeIdInListIdAll: (state, action) => {
      state.selectCheckBox.listIdAllByTerm =
        state.selectCheckBox.listIdAllByTerm.filter(
          (item) => !action.payload.includes(item),
        )
    },
    changeValidateNameCreatePortfolio: (state, { payload = '' }) => {
      state.validateNameCreatePortfolio = payload
    },
  },
  extraReducers: (builder) => {
    //getSearchPortfolio
    builder.addCase(getSearchPortfolio.pending, (state) => {
      state.isLoading.savedPortfolioTable = true
    })
    builder.addCase(getSearchPortfolio.fulfilled, (state, action) => {
      state.idsTableSavedPortfolio = getListIdTableSavePortfolio(
        action.payload.data,
      )
      state.dataTableSavedPortfolio = convertDataTableSavePortfolio(
        action.payload.data,
      )
      state.dataPage = getDataSizeTable(action.payload, state.dataPage)
      state.textSearch = action.meta.arg?.term
      state.dataRawTableSavedPortfolio = action.payload.data
      state.isLoading.savedPortfolioTable = false
    })
    builder.addCase(getSearchPortfolio.rejected, (state) => {
      state.dataTableSavedPortfolio = {}
      state.idsTableSavedPortfolio = []
      state.dataRawTableSavedPortfolio = []
      state.isLoading.savedPortfolioTable = false
    })

    //Get data header SavedPortfolio
    builder.addCase(getHeaderSavedPortfolio.pending, (state) => {
      state.isLoading.headerSavedPortfolio = true
    })
    builder.addCase(getHeaderSavedPortfolio.fulfilled, (state, action) => {
      state.total = action.payload
      state.isLoading.headerSavedPortfolio = false
    })
    builder.addCase(getHeaderSavedPortfolio.rejected, (state) => {
      state.isLoading.headerSavedPortfolio = false
    })

    //Get type AlertProfile
    builder.addCase(getAlertProfile.pending, (state) => {
      state.isLoading.alertProfile = true
    })
    builder.addCase(getAlertProfile.fulfilled, (state, action) => {
      state.typeAlert = convertTypeAlert(action.payload)
      state.isLoading.alertProfile = false
    })
    builder.addCase(getAlertProfile.rejected, (state, action) => {
      state.isLoading.alertProfile = action.payload.loading
    })

    //search Company
    builder.addCase(getSearchCompany.pending, (state) => {
      state.isLoading.searchCompany = true
    })
    builder.addCase(getSearchCompany.fulfilled, (state, action) => {
      state.dataSearchCompany = action.payload
      state.isLoading.searchCompany = false
    })
    builder.addCase(getSearchCompany.rejected, (state, action) => {
      state.isLoading.searchCompany = action.payload.loading
      state.dataSearchCompany = []
    })

    //get data search Portfolio By Org
    builder.addCase(getSavedPortfolioByOrg.pending, (state) => {
      state.isLoading.savedPortfolioTable = true
    })
    builder.addCase(getSavedPortfolioByOrg.fulfilled, (state, action) => {
      state.idsTableSavedPortfolio = getListIdTableSavePortfolio(
        action.payload.data,
      )
      state.dataTableSavedPortfolio = convertDataTableSavePortfolio(
        action.payload.data,
      )
      state.dataPage = getDataSizeTable(action.payload, state.dataPage)
      state.isLoading.savedPortfolioTable = false
    })
    builder.addCase(getSavedPortfolioByOrg.rejected, (state) => {
      state.isLoading.savedPortfolioTable = false
    })
    //postCreatePortfolio
    builder.addCase(postCreatePortfolio.rejected, (state, action) => {
      state.validateNameCreatePortfolio = action.payload.message
    })

    //getSearchPortfolioAll
    builder.addCase(getSearchPortfolioAll.pending, (state) => {
      state.isLoading.savedPortfolioTableAll = true
    })
    builder.addCase(getSearchPortfolioAll.fulfilled, (state, action) => {
      state.selectCheckBox.listIdAllByTerm = action.payload
      state.isLoading.savedPortfolioTableAll = false
    })
    builder.addCase(getSearchPortfolioAll.rejected, (state) => {
      state.isLoading.savedPortfolioTableAll = false
    })
    //getIDPortfolioAllByOrg
    builder.addCase(getIdPortfolioAllByOrg.pending, (state) => {
      state.isLoading.getAllIdByPort = true
    })
    builder.addCase(getIdPortfolioAllByOrg.fulfilled, (state, action) => {
      state.selectCheckBox.listIdAllByTerm = action.payload
      state.isLoading.getAllIdByPort = false
    })
    builder.addCase(getIdPortfolioAllByOrg.rejected, (state) => {
      state.isLoading.getAllIdByPort = false
    })
  },
})

//table
export const selectDataRawTable = (state) =>
  state[slice.name].dataRawTableSavedPortfolio
export const selectIds = (state) => state[slice.name].idsTableSavedPortfolio
export const selectDataReduxTableSavedPortfolio = (rowId) => (state) =>
  state[slice.name].dataTableSavedPortfolio[rowId]
export const selectDataTable = (rowId, colId) => (state) => {
  return state[slice.name]?.dataTableSavedPortfolio[rowId][colId]
}
//checkbox table
export const selectCheckboxPortfolio =
  (attr = [], callback) =>
  (state) => {
    const data = attr.reduce(
      (result, key) => result[key],
      state[slice.name].selectCheckBox,
    )
    return callback ? callback(data) : data
  }

export const selectIsLoadingTableSavedPortfolio = (state) =>
  state[slice.name].isLoading.savedPortfolioTable

export const selectDataPageTableSavedPortfolio = (state) =>
  state[slice.name].dataPage

export const selectFilter = (state) => state[slice.name].filter

//header
export const selectTotal = (state) => state[slice.name].total

//Type Alert Portfolio typeAlert
export const selectTypeAlert = (state) => state[slice.name].typeAlert
export const selectIsLoadingTypeAlert = (state) =>
  state[slice.name].isLoading.alertProfile

//data search Company
export const selectDataSearchCompany = (state) =>
  state[slice.name].dataSearchCompany

export const selectTextSearch = (state) => state[slice.name].textSearch
export const selectIDCompanySearch = (state) =>
  state[slice.name].idCompanySearch

//loading
export const getLoadingSavedPortfolio = (type) => (state) => {
  return type ? state[slice.name].isLoading[type] : state[slice.name].isLoading
}
export const selectTextSearchAddCompany = (state) =>
  state[slice.name].textSearchAddCompany

export const selectTextValidateNamePortfolio = (state) =>
  state[slice.name].validateNameCreatePortfolio

export const {
  changeDataInRow,
  changePageSizeTable,
  changeFilter,
  resetStore,
  changeIdCompanySearch,
  clearDataTable,
  changeTextSearchAddCompany,
  clearValidateNameCreatePortfolio,
  clearSearchCompany,
  changeCheckboxTable,
  selectAllIdInTable,
  selectAllIdByTerm,
  unSelectAllCheckbox,
  removeIdInListIdAll,
  changeValidateNameCreatePortfolio,
} = slice.actions

register(slice.name, slice.reducer)
